import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { GapsFilters } from '../types';

export const gapKeys = {
  all: ['gaps'] as const,
  summary: (filters: GapsFilters) => [...gapKeys.all, 'summary', filters] as const,
  trends: (filters: GapsFilters) => [...gapKeys.all, 'trends', filters] as const,
  details: (filters: GapsFilters) => [...gapKeys.all, 'details', filters] as const,
};

export function useGapsSummary(filters: GapsFilters) {
  return useQuery({
    queryKey: gapKeys.summary(filters),
    queryFn: () => api.getGapsSummary(filters),
  });
}

export function useGapsTrends(filters: GapsFilters) {
  return useQuery({
    queryKey: gapKeys.trends(filters),
    queryFn: () => api.getGapsTrends(filters),
  });
}

export function useGapsDetails(filters: GapsFilters & { limit?: number }) {
  return useQuery({
    queryKey: gapKeys.details(filters),
    queryFn: () => api.getGapsDetails(filters),
  });
}
